module.exports = __webpack_public_path__ + "static/media/ecabin_white.735a116c.png";